import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-shared-no-results',
  templateUrl: './no-results.component.html',
  styleUrls: ['./no-results.component.scss'],
})
export class NoResultsComponent {
  @Input() title?: string = 'No results found';
  @Input() message?: string =
    "Try adjusting your search to find what you're looking for.";
}
